import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useReduxState from '@portal/hooks/useReduxState';
import { getWebviewUrl } from '@portal/actions/onboarding';

const WebviewDocuments = () => {
  const dispatch = useDispatch();
  const {
    onboarding: { webviewUrl },
  } = useReduxState();

  useEffect(() => {
    dispatch(getWebviewUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderWebview = useMemo(() => {
    if (webviewUrl?.url) {
      return (
        <div style={{ height: '100vh' }}>
          <iframe src={webviewUrl.url} height="100%" width="100%" />
        </div>
      );
    } else {
      return <></>;
    }
  }, [webviewUrl]);
  return renderWebview;
};

export default WebviewDocuments;
